import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import AccrediteddateRepository from '@/shared/http/repositories/realestate/accrediteddate'
import ActionsForm from '@/shared/mixins/actionsForm'
import {mask} from 'vue-the-mask'
import { toast, loading } from '@/shared/utils/UIHelper'
import axios from 'axios'

export default {
  name: 'Detailaccredited',
  mixins: [ActionsForm],
  components: {HeadDetailsGama},
  props: ['editData'],
  data () {
    return {
      editData: {
        nome: '',
        telefoneComercial: '',
        emailComercial: '',
        DatePlaceholder: '',
        creci: '',
        cep: '',
        cidade: {
          nome: ''
        },
        percentualComissao: '',
        endereco: '',
        bairro: '',
        numero: ''
      }
    }
  },
  methods: {

    validateState (ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) {
        return !this.errors.has(ref)
      }
      return null
    },
    cancelNewAccredited (e) {
      e.preventDefault()
      this.$refs['add-user-modal'].hide()
      Object.keys(this.newAccreditedData).forEach(key => {
        if (key === 'dateBirth') {
          this.newAccreditedData[key] = null
        } else {
          this.newAccreditedData[key] = ''
        }
      })
    },
    onSubmit (e) {
      loading.push()
      this.$validator.validateAll().then(result => {
        if (!result) {
          return
        }
        let sendData = {}
        Object.assign(sendData, this.editData)
        sendData.telefoneComercial = sendData.telefoneComercial.replace(/[().-]/gm, '')
        sendData.cep = sendData.cep.replace(/[().-]/gm, '')
        sendData.percentualComissao = parseInt(sendData.percentualComissao.replace('%', ''))
        AccrediteddateRepository.PutCredenciada(sendData)
          .then(res => {
            if (res.status === 200) {
              toast.success(`Alterações salvas com sucesso`)
              loading.pop()
            }
          })
          .catch(() => {
            toast.error(`Erro ao salvar mudanças`)
            loading.pop()
          })
      })
    },

    formatPercentage (value, e) {
      value = value.replace(/\D/gm, '')
      let valueInt = parseInt(value)

      if (valueInt > 100) {
        value = '100'
      }

      if (valueInt < 1) {
        value = '1'
      }

      if (value !== '' && e.inputType !== 'deleteContentBackward') {
        value += '%'
      }
      return value
    },
    formatLazyPercentage (value) {
      let valueInt = parseInt(value)

      if (valueInt > 100) {
        value = '100'
      }

      if (valueInt < 0) {
        value = '1'
      }
      value += '%'
      return value
    },
    searchAndress () {
      axios({
        method: 'GET',
        url: `https://viacep.com.br/ws/${this.editData.cep}/json/`
      }).then(res => {
        if (!('erro' in res.data)) {
          let data = res.data
          if (res.status === 200) {
            this.editData.cidade.nome = data.localidade
            this.editData.endereco = data.logradouro
            this.editData.bairro = data.bairro
          }
        }
      })
        .catch(() => {})
    }
  },
  mounted () {
    if (!`${this.editData.percentualComissao}`.includes('%')) {
      this.editData.percentualComissao += '%'
    }
  },
  directives: {mask}
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/detailaccredited/detailaccredited.js